// THIS IS A GENERATED FILE
import * as Types from '@gatsbyjs/graphql/types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';


export type ConnectAzureToSiteMutationVariables = Types.Exact<{
  siteId: Types.Scalars['UUID'];
  config: Types.AzureConnectionInput;
}>;


export type ConnectAzureToSiteMutation = (
  { __typename?: 'Mutation' }
  & { connectAzureToSite?: Types.Maybe<(
    { __typename?: 'MutationResult' }
    & Pick<Types.MutationResult, 'success' | 'message' | 'errorType'>
  )> }
);


export const ConnectAzureToSiteDocument = gql`
    mutation ConnectAzureToSite($siteId: UUID!, $config: AzureConnectionInput!) {
  connectAzureToSite(siteId: $siteId, config: $config) {
    success
    message
    errorType
  }
}
    `;
export type ConnectAzureToSiteMutationFn = ApolloReactCommon.MutationFunction<ConnectAzureToSiteMutation, ConnectAzureToSiteMutationVariables>;

/**
 * __useConnectAzureToSiteMutation__
 *
 * To run a mutation, you first call `useConnectAzureToSiteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConnectAzureToSiteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [connectAzureToSiteMutation, { data, loading, error }] = useConnectAzureToSiteMutation({
 *   variables: {
 *      siteId: // value for 'siteId'
 *      config: // value for 'config'
 *   },
 * });
 */
export function useConnectAzureToSiteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ConnectAzureToSiteMutation, ConnectAzureToSiteMutationVariables>) {
        return ApolloReactHooks.useMutation<ConnectAzureToSiteMutation, ConnectAzureToSiteMutationVariables>(ConnectAzureToSiteDocument, baseOptions);
      }
export type ConnectAzureToSiteMutationHookResult = ReturnType<typeof useConnectAzureToSiteMutation>;
export type ConnectAzureToSiteMutationResult = ApolloReactCommon.MutationResult<ConnectAzureToSiteMutation>;
export type ConnectAzureToSiteMutationOptions = ApolloReactCommon.BaseMutationOptions<ConnectAzureToSiteMutation, ConnectAzureToSiteMutationVariables>;
